import React from 'react';
import {
  MessageCircle, BookOpen, ShieldCheck, Users,
  AlertTriangle, FileText, Search, Zap,
  FolderLock, ClipboardList, Edit3, Folder,
  Bell, HelpCircle, ArrowRight,
} from 'lucide-react';

const ICONS = {
  MessageCircle, BookOpen, ShieldCheck, Users,
  AlertTriangle, FileText, Search, Zap,
  FolderLock, ClipboardList, Edit3, Folder,
  Bell, HelpCircle,
};

/* Per-category accent color — matches the CATEGORIES table. */
const CATEGORY_ACCENT = {
  'get-answers':    '#67e8f9',
  'protect-rights': '#facc15',
  'build-case':     '#a78bfa',
  'follow-up':      '#4ade80',
};

/**
 * ToolCard — a single tool card in the Command Center.
 * Renders as a semantic <a href> so browser default keyboard/right-click
 * work; onClick is used for internal SPA navigation (respects modifiers
 * for "open in new tab" behavior).
 */
export default function ToolCard({ tool, featured = false, onSelect }) {
  const Icon = ICONS[tool.icon] || FileText;
  const accent = CATEGORY_ACCENT[tool.category] || '#67e8f9';

  function handleClick(e) {
    // Preserve cmd/ctrl-click, middle-click, shift-click → open normally.
    if (e.defaultPrevented) return;
    if (e.button !== 0) return;
    if (e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;
    e.preventDefault();
    onSelect?.(tool);
  }

  return (
    <a
      href={tool.route}
      onClick={handleClick}
      className={`cc-card ${featured ? 'cc-card-featured cc-grid-featured' : ''}`}
      style={{ '--cc-c': accent }}
      data-testid={`cc-tool-${tool.id}`}
      aria-label={`${tool.title}: ${tool.description}`}
    >
      {featured && <span className="cc-card-badge">Recommended</span>}
      <span className="cc-card-icon" aria-hidden="true">
        <Icon size={featured ? 22 : 20} strokeWidth={2.2} />
      </span>
      <h3 className="cc-card-title">{tool.title}</h3>
      <p className="cc-card-desc">{tool.description}</p>
      <span className="cc-card-cta">
        {tool.actionLabel}
        <ArrowRight size={14} strokeWidth={2.5} />
      </span>
    </a>
  );
}
